const SP_SITE_ID = process.env.REACT_APP_SP_SITE_ID;

export enum Page {
  HO_AFL = "HO_AFL", // Application for leave
  HO_AIR = "HO_AIR", // Accident investigation record
  HO_EC = "HO_EC", // Employee confirmation
}

export const urlHelper = {
  getBaseUrl(page: Page) {
    if (page === Page.HO_AFL) {
      const SP_LIST_ID = process.env.REACT_APP_APPLICATION_FOR_LEAVE_LIST_ID;
      return `/sites/${SP_SITE_ID}/lists/${SP_LIST_ID}/items`;
    }
    if (page === Page.HO_AIR) {
      const SP_LIST_ID =
        process.env.REACT_APP_ACCIDENT_INVESTIGATION_RECORD_LIST_ID;
      return `/sites/${SP_SITE_ID}/lists/${SP_LIST_ID}/items`;
    }
    return "";
  },
};
